import styled from 'styled-components';

export const HotelFilterSectionWrapper = styled.section`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white};

  button {
    display: block;
    padding: 0;
    margin: 10px 0 0;
    border: 0;
    background: transparent;
    color: ${({ theme }) => theme.palette.clearBlue};
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }

  .setur-collapse-header {
    padding: 0 !important;
  }

  .setur-collapse-content-active {
    margin-top: 10px;
  }
`;

export const HotelFilterSectionHeading = styled.h3`
  margin: 0 0 12px;
  color: rgb(47, 49, 55);
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`;

export const HotelFilterCard = styled.div`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white};
`;

export const HotelFilterSectionTitle = styled.span`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`;

export const HotelFilterSectionContent = styled.div`
  margin-top: 10px;
`;

export const HotelFilterItemsWrapper = styled.div<{ $isScrollable?: boolean }>`
  ${({ $isScrollable }) =>
    $isScrollable &&
    `
    max-height: 400px;
    overflow-y: auto;
    padding-right: 4px;
  `}
`;

export const HotelFilterSectionSearchWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  padding: 0 10px;
  margin-bottom: 10px;
  border: 1px solid ${({ theme }) => theme.palette.inputBorderColor};
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.inputBackgroundColor};
`;

export const HotelFilterSectionSearchInput = styled.input`
  width: 100%;
  height: 100%;
  padding-left: 8px;
  border: 0;
  outline: 0;
  background: transparent;
  color: ${({ theme }) => theme.palette.inputColor};
  font-size: 14px;
`;
